"use strict";

var _interopRequireDefault = require("E:/dianlala_project/\u7535\u5566\u5566/cd-vue-admin/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
require("core-js/modules/es7.object.get-own-property-descriptors");
require("core-js/modules/web.dom.iterable");
require("core-js/modules/es6.object.keys");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _defineProperty2 = _interopRequireDefault(require("E:/dianlala_project/\u7535\u5566\u5566/cd-vue-admin/node_modules/@babel/runtime/helpers/defineProperty.js"));
var _vuex = require("vuex");
var _Logo = _interopRequireDefault(require("./Logo"));
var _SidebarItem = _interopRequireDefault(require("./SidebarItem"));
var _variables2 = _interopRequireDefault(require("@/styles/variables.scss"));
var _qrcodejs = _interopRequireDefault(require("qrcodejs2"));
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  components: {
    SidebarItem: _SidebarItem.default,
    Logo: _Logo.default
  },
  computed: _objectSpread(_objectSpread({}, (0, _vuex.mapGetters)(['permission_routes', 'sidebar', 'avatar'])), {}, {
    agentInfo: function agentInfo() {
      var agentInfo = this.$store.state.user.agentInfo;
      if (this.checkRoles(['partner']) && agentInfo.id) this.getContract(agentInfo.id);
      return agentInfo;
    },
    activeMenu: function activeMenu() {
      var route = this.$route;
      var meta = route.meta,
        path = route.path;
      // if set path, the sidebar will highlight the path you set
      if (meta.activeMenu) {
        return meta.activeMenu;
      }
      return path;
    },
    showLogo: function showLogo() {
      return this.$store.state.settings.sidebarLogo;
    },
    variables: function variables() {
      return _variables2.default;
    },
    isCollapse: function isCollapse() {
      return !this.sidebar.opened;
    }
  }),
  data: function data() {
    return {
      contractInfo: {},
      renewalInfo: {},
      renewalDialog: false,
      contract_type: 0,
      moneyArr: []
    };
  },
  mounted: function mounted() {},
  methods: {
    /**
       * 获取合同
       */
    getContract: function getContract(id) {
      var _this = this;
      this.$get('agentapi/pay/contract_order', {
        renew_agent_id: id
      }).then(function (res) {
        var attach_info = res.attach_info;
        var now = Date.parse(new Date()) / 1000;
        _this.moneyArr = res.service_save_data;
        _this.contract_type = attach_info.date_type;
        attach_info.renewalStatus = now >= attach_info.end_date ? 1 : now >= attach_info.end_date - 518400 ? 2 : 0;
        _this.contractInfo = attach_info;
        if (attach_info.renewalStatus > 0 && attach_info.end_date > 0 && attach_info.date_type != 0) _this.renewal();
      });
    },
    /**
       * 续费
       */
    renewal: function renewal() {
      var _this2 = this;
      this.$get('agentapi/pay/get_contract_qrcode', {
        contract_type: this.contract_type,
        renew_agent_id: this.agentInfo.id
      }).then(function (res) {
        _this2.renewalDialog = true;
        _this2.renewalInfo = res;
        setTimeout(function () {
          document.getElementById('qrcode').innerHTML = '';
          new _qrcodejs.default('qrcode', {
            width: 150,
            height: 150,
            text: res.wx_qrcode_url
          });
          document.getElementById('qrcode_ali').innerHTML = '';
          new _qrcodejs.default('qrcode_ali', {
            width: 150,
            height: 150,
            text: res.zfb_qrcode_url
          });
        }, 500);
      });
    }
  }
};